const gsap = window.gsap;

// Video pause/play toggle — WCAG 2.2.2: user must be able to pause auto-playing media.
const videoToggle = document.querySelector( '[data-hero-video-toggle]' );
if ( videoToggle ) {
	const video     = videoToggle.closest( 'section' )?.querySelector( 'video' );
	const pauseIcon = videoToggle.querySelector( '[data-hero-video-pause-icon]' );
	const playIcon  = videoToggle.querySelector( '[data-hero-video-play-icon]' );

	if ( video ) {
		videoToggle.addEventListener( 'click', () => {
			if ( video.paused ) {
				video.play();
				videoToggle.setAttribute( 'aria-pressed', 'false' );
				videoToggle.setAttribute( 'aria-label', 'Pause background video' );
				pauseIcon.hidden = false;
				playIcon.hidden  = true;
			} else {
				video.pause();
				videoToggle.setAttribute( 'aria-pressed', 'true' );
				videoToggle.setAttribute( 'aria-label', 'Play background video' );
				pauseIcon.hidden = true;
				playIcon.hidden  = false;
			}
		} );
	}
}

// Entrance animations — skipped when user prefers reduced motion (WCAG 2.3.3).
// Initial hidden state is applied via CSS class (.hero-animate-ready) added here by JS,
// so content remains fully visible if this script fails to load or GSAP errors.
if (! window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {
	const heroContent = document.querySelector( '[data-hero-animate="content"]' );
	const heroSection = heroContent?.closest( 'section' );

	if ( heroSection ) {
		heroSection.classList.add( 'hero-animate-ready' );

		const tl = gsap.timeline( { delay: 0.5, defaults: { ease: 'expo.out', duration: 1 } } );

		tl.fromTo( heroContent, { y: 20 }, { opacity: 1, y: 0 } );
	}
}
